import { Link } from '@tanstack/react-router'

import { Plus } from 'lucide-react'

import { SectionDescription, SectionTitle } from '@/features/app-shell/section'

import { HasActiveSystemManager } from '@/shared/auth/components/has-active-system-manager'

import { Button } from '@/components/ui/button'

import { networkLogCatalogLink } from '../catalog-link'

/**
 * The page's title and its two add affordances.
 *
 * Lives outside the list's Suspense/Error boundary and renders identically in
 * every state (P-05): both destinations are reachable whether or not the list
 * resolved, and a user whose Collectors failed to load must still be able to add
 * one.
 *
 * Two buttons because they create two different things. `Add integration` adds a
 * **Log Source** — a connector hosted on an existing Collector — and so goes to
 * the shared catalog. `Add remote collector` adds the **host** itself. Collapsing
 * them into one menu would hide the fact that the second is a prerequisite for
 * the first.
 */
export const CollectorsListHeader = () => {
	return (
		<div className="flex w-full flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
			<div className="flex flex-col gap-1">
				<SectionTitle>Network Collectors</SectionTitle>
				<SectionDescription>
					Remote collectors receiving syslog on-site and shipping to AIR®.
				</SectionDescription>
			</div>

			<HasActiveSystemManager>
				<div className="flex shrink-0 items-center gap-3">
					<Button
						variant="outline"
						nativeButton={false}
						render={
							<Link {...networkLogCatalogLink()} preload="intent">
								<Plus className="size-4" /> Add integration
							</Link>
						}
					/>

					<Button
						nativeButton={false}
						render={
							<Link to="/integrations/collectors/new" preload="intent">
								<Plus className="size-4" /> Add remote collector
							</Link>
						}
					/>
				</div>
			</HasActiveSystemManager>
		</div>
	)
}
